import styled from 'styled-components';

import Box from '../../../../_shared/components/Box';
import Label from '../../../../_shared/components/Label';

export const StyledBox = styled(Box)`
  width: 100%;
  background: ${({ theme }) => theme.COLORS.BASE};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 18px;
  min-height: 42px;
  border-left: 6px solid ${({ theme }) => theme.COLORS.TERTIARY};
  border-radius: 0 0 3px 3px;
  border-right: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
  border-bottom: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
`;

export const StyledEnd = styled(Label.Bold)`
  margin: auto;
  margin-left: 30px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
`;

export const StyledJumpToStart = styled.a`
  margin: auto;
  margin-right: 24px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: ${({ theme }) => theme.FONT_SIZES.BASE};
  cursor: pointer;
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  background-color: ${({ theme }) => theme.COLORS.BASE};
  text-decoration: underline;
  text-decoration-color: ${({ theme }) => theme.COLORS.NEUTRAL_20};
`;
